import {createI18n} from "vue-i18n";
import axios from "axios";
import en from "../locales/en.json";
import de from "../locales/de.json";
import nl from "../locales/nl.json";

export const SUPPORT_LOCALES = ["en", "nl", "de"];

export function setupI18n(
    options = {locale: "en", allowComposition: true, warnHtmlInMessage: "off"}
) {
    let locale = null;

    // get the locale from the querystring
    // if it's not set, we use the browser locale
    if (window.location.search.includes("locale=")) {
        locale = window.location.search.split("locale=")[1];
        if (locale == null) {
            try {
                locale = new Intl.Locale(navigator.language).language;
            } catch (e) {
            }
        }
    }

    if (locale == null) {
        locale = localStorage.getItem("locale");
    }

    if (!SUPPORT_LOCALES.includes(locale)) {
        locale = options.locale;
    }
    
    localStorage.setItem("locale", locale);

    const i18n = createI18n({
        legacy: false,
        locale,
        fallbackLocale: "en",
        messages: {
            en,
            de,
            nl,
        },
    });

    setI18nLanguage(i18n, locale);

    return i18n;
}

export function setI18nLanguage(i18n, locale) {
    if (i18n.mode === "legacy") {
        i18n.global.locale = locale;
    } else if (i18n.global) {
        i18n.global.locale.value = locale;
    } else {
        i18n.locale = locale;
    }
    axios.defaults.headers.common["Accept-Language"] = locale;

    document.querySelector("html").setAttribute("lang", locale);
}
